export const DESCRIPTION = 'Fuel Better. Save up to 25¢/gal by enrolling into our Pay with GasBuddy program and download our app to save the most.';
export const THUMBNAIL = 'https://images.gasbuddy.com/images/websites/gasbuddy/apps/cellphone-app.png';
export const TITLE = 'GasBuddy - Most ways, most places to save money on gas';
